import styled, {css} from "styled-components";
import PropTypes from "prop-types";

/**
 * Generic image component
 */
const Image = styled.img`
  ${props => props.width && css`
    width: ${props.width};
  `}
  ${props => props.height && css`
    height: ${props.height};
  `}
`;

Image.propTypes = {
  /** Image source (URL or reference) */
  alt: PropTypes.string,

  /** Alt text */
  height: PropTypes.string,

  /** Width of the image */
  src: PropTypes.string.isRequired,

  /** Height of the image */
  width: PropTypes.string
};

/** @component */
export default Image;
